import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Select, Button } from 'antd';
// 使用 window.message 代替 antd 静态方法，避免 context 警告
import userService from '../../services/userService';
import { getCurrentUser } from '../../services/authService';
import { CAREER_OPTIONS, TRACK_OPTIONS, GRADE_OPTIONS, MAJOR_OPTIONS } from '../../utils/constants';

const { Option } = Select;

const EditTagsModal = ({ visible, onCancel, onSave, initValues = {} }) => {
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (visible) {
      // 从 education 数组中提取第一个教育经历作为默认值
      const firstEducation = initValues.education && initValues.education.length > 0 ? initValues.education[0] : {};
      
      form.setFieldsValue({
        institution: firstEducation.institution || '',
        field: firstEducation.field || '',
        degree: firstEducation.degree || '',
        major: firstEducation.major || '',
        expected_career: initValues.preferences?.expected_career || '',
        expected_scenario: initValues.preferences?.expected_scenario || '',
      });
    }
  }, [visible, initValues, form]);





  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      setSaving(true);
      const userId = getCurrentUser()?.id;
      
      // 构建新的 payload 格式
      const payload = {
        preferences: {
          expected_career: values.expected_career || '',
          expected_scenario: values.expected_scenario || '',
        },
        education: (values.institution || values.field || values.degree || values.major) ? [{
          institution: values.institution || '',
          major: values.major || '',
          field: values.field || '',
          degree: values.degree || '',
        }] : [],
      };
      
      await userService.updateUserInfo(userId, payload);
      window.message?.success('保存成功');
      onSave && onSave(payload);
      onCancel && onCancel();
    } catch {
      window.message?.error('保存失败');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      title="编辑标签与信息"
      open={visible}
      onCancel={onCancel}
      onOk={handleOk}
      width={480}
      destroyOnClose
      confirmLoading={saving}
      footer={[
        <Button key="cancel" onClick={onCancel} disabled={saving}>取消</Button>,
        <Button key="ok" type="primary" onClick={handleOk} loading={saving}>保存</Button>,
      ]}
    >
      <Form form={form} layout="vertical">
        <Form.Item label="预期职业" name="expected_career">
          <Select placeholder="请选择预期职业" allowClear disabled={saving}>
            {CAREER_OPTIONS.map(opt => <Option key={opt} value={opt}>{opt}</Option>)}
          </Select>
        </Form.Item>
        <Form.Item label="预期场景" name="expected_scenario">
          <Select placeholder="请选择预期场景" allowClear disabled={saving}>
            {TRACK_OPTIONS.map(opt => <Option key={opt} value={opt}>{opt}</Option>)}
          </Select>
        </Form.Item>
        <Form.Item label="专业/学科" name="major">
          <Select placeholder="请选择专业/学科" allowClear disabled={saving}>
            {MAJOR_OPTIONS.map(opt => <Option key={opt} value={opt}>{opt}</Option>)}
          </Select>
        </Form.Item>
        <Form.Item label="大学" name="institution">
          <Input placeholder="请输入大学名称" maxLength={20} disabled={saving} />
        </Form.Item>
        <Form.Item label="院系/学科领域" name="field">
          <Input placeholder="请输入院系或学科领域" maxLength={20} disabled={saving} />
        </Form.Item>
        <Form.Item label="学历" name="degree">
          <Select placeholder="请选择学历" allowClear disabled={saving}>
            {GRADE_OPTIONS.map(opt => <Option key={opt} value={opt}>{opt}</Option>)}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditTagsModal; 